import { Box } from "@mui/material";
import React from "react";
import NumberedTitle from "../../Components/Title";
import DocReviewer from "../../../../DCSTab/DocReviewer";

export default function ITPTab() {
  return (
    <Box>
      <NumberedTitle number="5" title="Inspection & Test Plan" />
      {/* Show DCS Doc Reviewer filtered to Quality Control documents for this plant */}
      <Box mt={2}>
        <DocReviewer plant initialType="Quality Control" hideTypeSelector={true} />
      </Box>
    </Box>
  );
}
